<script lang="ts">
	import { google, outlook, office365, yahoo, ics, type CalendarEvent } from 'calendar-link'; // current version of this breaks in "npm run preview" when browser refreshed event page. Therefor fixed version
	import { routes, withHost } from '$lib/routes';
	import type { UiEvent } from '$lib/server/supabase';
	import { user } from '$lib/stores/user';

	interface Props {
		event: UiEvent;
		[key: string]: any
	}

	let { ...props }: Props = $props();
	let showLinks = $state(false);


	function openLinks() {
		showLinks = true;
		setTimeout(() => document.addEventListener('click', hideLinks), 100);
	}

	function hideLinks() {
		showLinks = false;
		document.removeEventListener('click', hideLinks);
	}

	function getCalendarEvent(event: UiEvent): CalendarEvent {
		let bringText = '';
		const myItems = event.items.filter((x) => x.user?.id === $user.id);
		if (myItems.length > 0) {
			bringText = '\n\nDas bringst du mit: ' + myItems.map((x) => x.name).reduce((p, c) => (c += ', ' + p));
		}

		return {
			title: event.name,
			start: event.beginAt ?? '',
			duration: [4, 'hour'] as any,
			description: event.description + bringText + '\n\n' + withHost(routes.event(event.slug)),
			location: event.location ?? '',
			url: withHost(routes.event(event.slug)),
			busy: true,
		};
	}
	let calendarEvent = $derived(getCalendarEvent(props.event));
	let googleLink = $derived(google(calendarEvent));
	let outlookLink = $derived(outlook(calendarEvent));
	let office365Link = $derived(office365(calendarEvent));
	let yahooLink = $derived(yahoo(calendarEvent));
	let icsLink = $derived(ics(calendarEvent));
</script>

<div class={props.class}>
	<button
		{...props}
		onclick={openLinks}
		title="In Kalender eintragen"
		class="btn btn-secondary flex items-center justify-center !p-[0.5rem] text-violet-700"
	>
		<svg
			width="1.2em"
			height="1.2em"
			viewBox="0 0 16 16"
			class="bi bi-calendar-plus"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
			/>
			<path
				fill-rule="evenodd"
				d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"
			/>
		</svg>
	</button>

	<div
		class="absolute z-10 rounded-md border bg-white py-2 shadow-2xl"
		style={`margin-top: -9rem;`}
		hidden={!showLinks}
		data-testid="add-to-calendar-list"
	>
		<a
			onclick={() => (showLinks = false)}
			href={googleLink}
			target="_blank"
			rel="noreferrer"
			class="block p-2 px-4 hover:bg-gray-200"
		>
			<img class="mr-2 inline h-6 w-6" src="/brands/logo-google.svg" alt="google logo" />
			Google
		</a>
		<a
			onclick={() => (showLinks = false)}
			href={icsLink}
			target="_blank"
			rel="noreferrer"
			class="block p-2 px-4 hover:bg-gray-200"
		>
			<img class="mr-2 inline h-6 w-6" src="/brands/logo-apple.svg" alt="apple logo" />
			Apple
		</a>
		<a
			onclick={() => (showLinks = false)}
			href={icsLink}
			target="_blank"
			rel="noreferrer"
			class="block p-2 px-4 hover:bg-gray-200"
		>
			<img class="mr-2 inline h-6 w-6" src="/brands/logo-outlook.svg" alt="outlook logo" />
			Outlook
		</a>
		<a
			onclick={() => (showLinks = false)}
			href={outlookLink}
			target="_blank"
			rel="noreferrer"
			class="block p-2 px-4 hover:bg-gray-200"
		>
			<img class="mr-2 inline h-6 w-6" src="/brands/logo-outlookcom.svg" alt="outlook logo" />
			Outlook Online
		</a>
		<a
			onclick={() => (showLinks = false)}
			href={office365Link}
			target="_blank"
			rel="noreferrer"
			class="block p-2 px-4 hover:bg-gray-200"
		>
			<img class="mr-2 inline h-6 w-6" src="/brands/logo-office365.svg" alt="office365 logo" />
			Office 365
		</a>
		<a
			onclick={() => (showLinks = false)}
			href={yahooLink}
			target="_blank"
			rel="noreferrer"
			class="block p-2 px-4 hover:bg-gray-200"
		>
			<img class="mr-2 inline h-6 w-6" src="/brands/logo-yahoo.svg" alt="yahoo logo" />
			Yahoo
		</a>
		<a
			onclick={() => (showLinks = false)}
			href={icsLink}
			target="_blank"
			rel="noreferrer"
			class="block p-2 px-4 hover:bg-gray-200"
		>
			Andere (ICS-Datei)
		</a>
	</div>
</div>
